/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GetServiceDetails {
    getFixupPrototypeFunction() { return GetServiceDetails.fixupPrototype; }

    static newInstance(model: Partial<GetServiceDetails>): GetServiceDetails {
        let obj = Object.assign(new GetServiceDetails(), model);
        GetServiceDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GetServiceDetails>): GetServiceDetails {
        if (!model) return null;
        return GetServiceDetails.newInstance(<GetServiceDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GetServiceDetails) {
        if (!obj) return;

        models.GetServiceDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GetServiceDetails): boolean {
        Object.setPrototypeOf(obj, GetServiceDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    message: string;

    /**
     * get service details response
     */
    data: any;

}
